import React, {useCallback, useEffect, useState} from "react";
import Graph from "./components/Graph";
import { Autocomplete, TextField } from '@mui/material';
import { styled } from "@mui/material/styles";
import { useMusicArtistSearch, useMusicArtist } from "./useMusicArtist";


const StyledAutocomplete = styled(Autocomplete)({
  "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
    // Default transform is "translate(14px, 20px) scale(1)""
    // This lines up the label with the initial cursor position in the input
    // after changing its padding-left.
    transform: "translate(34px, 20px) scale(1);",
    color: 'white'
  },
  "&.Mui-focused .MuiInputLabel-outlined": {
    color: "white"
  },
  "& .MuiAutocomplete-inputRoot": {
    color: "white",
    // This matches the specificity of the default styles at https://github.com/mui-org/material-ui/blob/v4.11.3/packages/material-ui-lab/src/Autocomplete/Autocomplete.js#L90
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-of-type': {
      // Default left padding is 6px
      paddingLeft: 26
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "white"
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "blue"
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "white"
    },
  }
});

const Home = () => {
  // console.log('Loading Home component');
  const [appState, setAppState] = useState({
    selectedArtist: '',
    searchTerm: ''
  });

  const { data: searchResults } = useMusicArtistSearch(appState.searchTerm)
  const { data: graphData } = useMusicArtist(appState.selectedArtist)

  // useEffect(() => {
  //   console.log('useEffect in Home')
  //   console.log({graphData})
  // }, [graphData])

  const onChangeSelectedArtist = useCallback((event, artist) => {
    console.log(`Retrieving collaborations for ${artist.name}`);
    const newAppState = Object.assign({}, appState, {selectedArtist: artist});
    setAppState(newAppState)
  }, [])

  const onChangeSearch = useCallback((event, search) => {
    const newAppState = Object.assign({}, appState, {searchTerm: search});
    setAppState(newAppState);
  }, [])

  const getOptionLabel = (artist) => {
    const disambiguation = artist.disambiguation ? ` (${artist.disambiguation})` : '';
    return `${artist.name}${disambiguation}`;
  }

  const dimensions = {
    width: 1200,
    height: 800,
    margin: { top: 30, right: 30, bottom: 30, left: 60 }
  };

  return (
    <div className="flex flex-col items-center justify-between h-screen overflow-scroll pt-4">
      <StyledAutocomplete
        disablePortal
        id="combo-box-demo"
        options={searchResults}
        onChange={onChangeSelectedArtist}
        onInputChange={onChangeSearch}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={(o,v) => o.id === v.id}
        sx={{ width: 300 }}
        renderInput={(params) => <TextField sx={{ fill: 'white', color: 'white', '& .MuiAutocomplete-popupIndicator': {fill: 'white', color: 'white'} }} {...params} label="Music Artist" />}
      />
      {graphData && <Graph data={graphData || {}} dimensions={dimensions}/>}
      
    </div>
  )
};

export default Home;